import {ActivityStreamId, CreateComment, ListActivitiesArgs} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function list(activityStreamId: ActivityStreamId, args: ListActivitiesArgs) {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/activity_streams/{activity_stream_id}/activities`,
    {path: {activity_stream_id: activityStreamId}, query: args},
  );
}

export async function comment(activityStreamId: ActivityStreamId, comment: CreateComment) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/activity_streams/{activity_stream_id}/comment`,
    {path: {activity_stream_id: activityStreamId}, body: comment},
  );
  await invalidateQueries([q.vendorToolkit.watchingQuestion.filter()]);
  return res;
}
